import { TypeExpertise } from './type-expertise';
import { User } from './user';
  import { Collaborateur } from './collaborateur';
import { Contact } from './contact';
import { Prestation } from './prestation';
import { Expertise } from './expertise';
import { InvoiceDetail } from './invoice-detail';
import * as moment from 'moment';

export class Invoice {

  public loading: boolean;
  public saved: boolean;
  public uidUpdate: number = 1;


	public id: number;
	public number: number;
	public note: string;
	public htva: number;
  public tva: number;
  public tvac: number;
	public status: number;
  public workflow: any;
  public type: number;
  public tot: any;
  public peppol_status: string;

	private _contact: Contact;
	private _expertise: Expertise;
	private _date_document: Date;
  private _date_echeance: Date;
	private _user: User;
  private _details: InvoiceDetail[] = [];


  	constructor(
  	) {}

  	set expertise(t: any) {
  		if (typeof t === 'number') {
  			this._expertise = Object.assign((new Expertise),{id: t});
  		} else if (t instanceof Expertise ) {
  			this._expertise = t;
  		} else {
  			this._expertise = Object.assign((new Expertise),t);
  		}
  	}

  	get expertise(): any {
  		return this._expertise;
  	}
  	set date_document(t: any) {

  		if (typeof t === 'string') {
  			this._date_document = moment(t).toDate();
  		} else if (t instanceof Date ) {
  			this._date_document = t;
  		}
  	}

  	get date_document(): any {
  		return this._date_document;
  	}
  	get date_documentStr(): any {
  		return moment(this._date_document).format('YYYY-MM-DD');
  	}
    set date_echeance(t: any) {

      if (typeof t === 'string') {
        this._date_echeance = moment(t).toDate();
      } else if (t instanceof Date ) {
        this._date_echeance = t;
      }
    }

    get date_echeance(): any {
      return this._date_echeance;
    }
    get date_echeanceStr(): any {
      return moment(this._date_echeance).format('YYYY-MM-DD');
    }

  	public toRequest(): any {

  		let a = Object.assign({},{
        id: this.id,
        number: this.number,
        date_document: this.date_documentStr,
        date_echeance: this.date_echeanceStr,
        note: this.note,
        contact_id: this.contact ? this.contact.id : null,
        user_id: this.user ? this.user.id : null,
        expertise_id: this.expertise ? this.expertise.id : null  		,
        invoice_data: this.details ? this.details.map(c => c.toRequest()) : null,
        type: this.type,

  		});
  		return a;
  	}

    get contact(): any {
      return this._contact;
    }
    set contact(t: any) {
      if (typeof t === 'number') {
        this._contact = Object.assign((new Contact),{id: t});
      } else if (typeof t === 'string' ) {
        this._contact = Object.assign((new Contact),{name: t});
      } else if (t instanceof Contact ) {
        this._contact = t;
      } else {
        this._contact = Object.assign((new Contact),t);
      }
    }
    get user(): any {
      return this._user;
    }
    set user(t: any) {

      if (typeof t === 'number') {
        this._user = Object.assign((new User),{id: t});
      } else if (t instanceof User ) {
        this._user = t;
      } else {
        this._user = Object.assign((new User),t);
      }
    }
   get details(): any[] {
      return this._details;
    }
    set details(t: any[]) {
      this._details = t.map(p => {
        if (typeof p === 'number') {
          return Object.assign((new InvoiceDetail),{id: p});
        } else if (p instanceof InvoiceDetail ) {
          return p;
        } else {
          return Object.assign((new InvoiceDetail),p);
        }
      });
    }
}
